/** Ключи `sort_by` для API `/tickets/` и заголовков таблицы */

export const TICKETS_DEFAULT_SORT_BY = 'updated_at' as const
/** По умолчанию в списке: колонка «Обновлён», сначала более старые обновления */
export const TICKETS_DEFAULT_SORT_ORDER = 'asc' as const
/** Вкладка «Мозгобот»: по умолчанию сначала недавно обновлённые */
export const TICKETS_AI_DEFAULT_SORT_ORDER = 'desc' as const

export type TicketsSortByKey =
  | 'status'
  | 'viewers'
  | 'priority'
  | 'project'
  | 'subject'
  | 'created_at'
  | 'updated_at'
  | 'weight'
  | 'assigned'
  | 'customer'
  | 'ticket_number'
  | 'channel'
  | 'messages'

export type TicketsSortOrder = 'asc' | 'desc' | 'newest'

export function parseTicketsSortOrder(v: string | null): TicketsSortOrder {
  if (v === 'newest') return 'newest'
  return v === 'asc' ? 'asc' : 'desc'
}

/**
 * Цикл по клику на ту же колонку: для дат `asc` → `desc` → сброс URL;
 * для остальных колонок `desc` → `asc` → сброс (первая явная сортировка обычно `desc`).
 */
export function cycleTicketsSortSearchParams(
  p: URLSearchParams,
  column: TicketsSortByKey,
  options: {
    defaultSortBy?: TicketsSortByKey
    defaultSortOrderWhenMissing?: TicketsSortOrder
  } = {},
): void {
  const defaultSortBy = options.defaultSortBy ?? TICKETS_DEFAULT_SORT_BY
  const defaultSortOrderWhenMissing =
    options.defaultSortOrderWhenMissing ?? TICKETS_DEFAULT_SORT_ORDER
  const cur = p.get('sort_by')
  const ordRaw = p.get('sort_order')
  const ord =
    ordRaw === 'asc' || ordRaw === 'desc' || ordRaw === 'newest'
      ? ordRaw
      : defaultSortOrderWhenMissing

  const isDateColumn = column === 'updated_at' || column === 'created_at'

  if (cur !== column) {
    p.set('sort_by', column)
    let initial: 'asc' | 'desc'
    if (!cur && column === defaultSortBy) {
      initial = defaultSortOrderWhenMissing === 'asc' ? 'desc' : 'asc'
    } else if (isDateColumn) {
      initial = 'asc'
    } else {
      initial = 'desc'
    }
    p.set('sort_order', initial)
    return
  }

  if (ord === 'asc') {
    if (isDateColumn) {
      p.set('sort_order', 'desc')
    } else {
      p.delete('sort_by')
      p.delete('sort_order')
    }
  } else {
    if (isDateColumn) {
      p.delete('sort_by')
      p.delete('sort_order')
    } else {
      p.set('sort_order', 'asc')
    }
  }
}
